import { combineReducers } from 'redux'

// Placeholder reducer - authentication reducer removed, to be reimplemented later.
const appReducer = (state = {}, action: any) => state;

export default combineReducers({
    app: appReducer,
})